// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixWindow from 'wix-window';

$w.onReady(function () {
    if (wixWindow.multilingual.currentLanguage ===  'es') {
        $w('#btnReadEN').hide();
        $w('#btnReadES').show();
		$w('#htmlMailchimpEN').hide()
		$w('#htmlMailchimpES').show()
    } else {
        $w('#btnReadEN').show();
        $w('#btnReadES').hide();
		$w('#htmlMailchimpEN').show()
		$w('#htmlMailchimpES').hide()
    }
});